export default "__VITE_ASSET__BUOCRUpW__"